import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, active }) => ({
    position: 'relative',
    maxWidth: toRem(1280),
    margin: '0 auto',
    padding: 0,
    '& .boatVideoInner': {
        height: '100%',
        position: 'relative',
        overflow: 'hidden'
    },
    '& .boatVideo': {
        width: '100%',
        height: '100%',
        minHeight: toRem(240),
        display: 'block',
        position: 'relative',
        margin: 0,
        overflow: 'hidden',
        borderRadius: 0,
        transition: 'border-radius 400ms ease-in-out 0s',
        [theme.breakpoints.up('lg')]: {
            borderRadius: toRem(4)
        },
        '&-video': {
            display: 'block',
            minWidth: '100%',
            width: '100%',
            height: '100%',
            minHeight: toRem(240),
            objectPosition: '50% 50%',
            objectFit: 'cover'
        }
    },
    '& .boatVideoOverlay': {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'transform 400ms ease-in-out 0s',
        ...(active && {
            transform: 'translate(0, -100%)'
        }),
        '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 27, 40, 0.01)',
            backdropFilter: 'blur(8px)'
        },
        '&-inner': {
            position: 'relative',
            width: '100%',
            margin: '0 auto',
            padding: toRems([0, 60]),
            transition: 'opacity 150ms ease-in-out 0s',
            [theme.breakpoints.up('md')]: {
                padding: toRems([0, 80])
            },
            [theme.breakpoints.up('lg')]: {
                padding: toRems([0, 160])
            },
            ...(active && {
                opacity: 0
            })
        },
        '& button': {
            '& > span': {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                '& svg': {
                    display: 'block',
                    marginLeft: toRem(20),
                    [theme.breakpoints.up('md')]: {
                        marginLeft: toRem(25)
                    }
                }
            }
        }
    },
    '& .boatVideoList': {
        listStyleType: 'none',
        margin: toRems([0, 0, 20, 0]),
        padding: 0,
        [theme.breakpoints.up('md')]: {
            marginBottom: toRem(40)
        },
        [theme.breakpoints.up('lg')]: {
            marginBottom: toRem(80)
        },
        '&-item': {
            display: 'block',
            margin: toRems([6, 0]),
            padding: 0,
            fontSize: toRem(14),
            lineHeight: '130%',
            transition: 'opacity 400ms ease-in-out 0s',
            pointerEvents: 'none',
            [theme.breakpoints.up('md')]: {
                margin: 0,
                fontSize: toRem(20)
            },
            [theme.breakpoints.up('lg')]: {
                fontSize: toRem(40)
            }
        }
    }
})

export default style
